import React, { useEffect, useState } from "react";
import { api, API } from "../lib/api";
import { toast } from "sonner";
import { Mic, Inbox, Play, Pause } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

function VoiceNoteCard({ note }) {
  const [playing, setPlaying] = useState(false);
  const audioRef = React.useRef(null);
  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) audioRef.current.pause(); else audioRef.current.play();
  };
  const src = `${API}/voice-notes/${note.voice_note_id}/audio`;  return (
    <div className="hifz-card flex items-center gap-4" data-testid={`voice-note-${note.voice_note_id}`}>
      <button onClick={toggle} className="h-11 w-11 rounded-full bg-forest-600 text-sand-100 grid place-items-center hover:bg-forest-700" data-testid={`voice-play-${note.voice_note_id}`}>
        {playing ? <Pause className="h-5 w-5" /> : <Play className="h-5 w-5" />}
      </button>
      <audio ref={audioRef} src={src} preload="none"
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} />
      <div className="flex-1 min-w-0">
        <div className="font-display font-semibold text-forest-700">{note.from_name}</div>
        {note.note && <div className="text-sm text-foreground/80 mt-0.5">{note.note}</div>}
        <div className="text-[11px] text-muted-foreground mt-1">{new Date(note.created_at).toLocaleString()}</div>
      </div>
    </div>
  );
}

export default function VoiceNotes() {
  const { t } = useLanguage();
  const [notes, setNotes] = useState(null);
  useEffect(() => {
    api.get("/voice-notes/mine").then((r) => setNotes(r.data)).catch(() => toast.error(t("voiceNotes.couldnTLoadVoiceNotes")));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-6" data-testid="voice-notes-page">
      <header>
        <div className="text-xs uppercase tracking-[0.22em] text-gold-600 font-semibold">{t("voiceNotes.fromYourTeacher")}</div>
        <h1 className="mt-1 font-display font-semibold text-4xl text-forest-700">{t("voiceNotes.voiceNotes")}</h1>
        <p className="mt-2 text-foreground/70 max-w-2xl">{t("voiceNotes.personalVoiceFeedbackFromYour")}</p>
      </header>
      {notes === null ? <div className="text-muted-foreground" data-testid="voice-loading">{t("hifzPlan.loading")}</div>
        : notes.length === 0 ? (
          <div className="hifz-card text-center py-16 text-muted-foreground" data-testid="voice-empty">
            <Inbox className="h-8 w-8 mx-auto opacity-50" />
            <p className="mt-3 text-sm">{t("voiceNotes.noVoiceNotesYetYour")}</p>
          </div>
        ) : (
          <ul className="space-y-3">
            {notes.map((n) => <li key={n.voice_note_id}><VoiceNoteCard note={n} /></li>)}
          </ul>
        )}
    </div>
  );
}
